import { Alert, Text } from '@nimbus-ds/components';
import { useTranslationCommon } from 'commons/hooks';
import { ImageGalleryState } from '../../ImageGallery';

interface AlertMaxImagesProps {
  maxImagesToLoad?: number;
  images: ImageGalleryState[];
}

function AlertMaxImages({ maxImagesToLoad, images }: AlertMaxImagesProps) {
  const t = useTranslationCommon();
  if (maxImagesToLoad === undefined || images.length <= maxImagesToLoad)
    return null;
  return (
    <Alert appearance="warning" show>
      <Text>
        {t('alertImagesExceededQuantity', {
          maxImagesToLoad,
        })}
      </Text>
    </Alert>
  );
}

export default AlertMaxImages;
